var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 44,
    viewBox: "0 0 39 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4136 29.8638L9.06913 9.16537L37.8627 4.82597C38.325 4.75444 38.6092 4.13342 38.3013 3.87164L34.6191 0.740882C34.4568 0.602916 34.2374 0.549062 33.9997 0.584038L2.93549 5.25866C2.65111 5.30131 2.36209 5.40721 2.088 5.56919C1.8139 5.73117 1.56114 5.94544 1.34685 6.19748C1.13255 6.44953 0.961725 6.73346 0.84594 7.03004C0.730156 7.32661 0.672121 7.62891 0.675766 7.91644L1.05633 39.516C1.05792 39.6406 1.10006 39.7428 1.17912 39.81L4.98619 43.0469C5.29409 43.3087 5.86598 42.9227 5.85754 42.4605L5.51347 13.3474L29.8579 34.0458C30.041 34.2014 30.3592 34.1307 30.5651 33.8886L33.3722 30.587C33.578 30.3449 33.5967 30.0194 33.4136 29.8638Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.41237773429bc7f4a38bb2283045ca6a.svg";
export { ForwardRef as ReactComponent };